export default "__VITE_ASSET__Le$f7tXJ__"